// extracted by css-extract-rspack-plugin
export default {"box":"product-detail-fragment__ProductGroup_box__8Gx8n","productGroupWrapper":"product-detail-fragment__ProductGroup_productGroupWrapper__YW5O6"};